import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './assets/beian.png';
const _withScopeId = (n) => (_pushScopeId("data-v-3d09e000"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "app" };
const _hoisted_2 = {
  class: "header-div",
  style: { "height": "40px", "width": "100%" }
};
const _hoisted_3 = {
  class: "flex",
  style: { "width": "784px", "margin": "0 auto" }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: { "width": "135px" } }, [
/*#__PURE__*/_createElementVNode("span", { class: "text-header" }, "400-000-3090")],
-1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-header" }, "合作", -1));
const _hoisted_6 = [
_hoisted_5];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-header" }, "招商", -1));
const _hoisted_8 = [
_hoisted_7];

const _hoisted_9 = { style: { "margin-left": "97px", "margin-right": "17px" } };
const _hoisted_10 = { class: "flex" };
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-header" }, "下载", -1));
const _hoisted_12 = { style: { "width": "100%", "height": "311px", "background": "#1C1C21" } };
const _hoisted_13 = { style: { "width": "1124px", "display": "flex", "color": "#FFFFFF", "margin": "0 auto", "font-size": "14px" } };
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: { "font-size": "24px", "letter-spacing": "1px", "margin-bottom": "10px" } }, "乙十睡眠", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: { "font-size": "14px", "letter-spacing": "3px" } }, "YISHI SLEEP", -1));
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = { style: { "color": "#666666", "font-size": "12px", "background": "rgb(242, 242, 242)" } };
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: { "height": "30px" } }, null, -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: { "margin-bottom": "8px" } }, [
/*#__PURE__*/_createElementVNode("a", {
  href: "/#/aboutUs",
  class: "eethree",
  seed: ""
}, "关于我们")],
-1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: { "margin-bottom": "8px" } }, [
/*#__PURE__*/_createElementVNode("a", {
  href: "mailto:contact@yi10bio.com",
  class: "eethree",
  seed: ""
}, "电子邮箱：contact@yi10bio.com"),
/*#__PURE__*/_createTextVNode(" | "),
/*#__PURE__*/_createElementVNode("a", {
  href: "tel:4000003090",
  class: "eethree",
  seed: ""
}, "联系电话：400-000-3090")],
-1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: { "margin-bottom": "8px" } }, [
/*#__PURE__*/_createElementVNode("a", {
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011702007338",
  class: "eethree"
}, [
/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: { "width": "20px", "height": "20px" }
}),
/*#__PURE__*/_createElementVNode("span", { style: { "display": "inline-block", "height": "100%", "line-height": "100%", "margin-left": "5px" } }, " 沪公网安备 31011702007338号 ")]
),
/*#__PURE__*/_createTextVNode(" | "),
/*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/#/Integrated/recordQuery",
  class: "eethree"
}, "沪ICP备19046737号-2"),
/*#__PURE__*/_createTextVNode(" | "),
/*#__PURE__*/_createElementVNode("a", {
  href: "http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020191127213619000005363353-SAIC_SHOW_310000-20200618161647473293&signData=MEYCIQCBTfZybW9GKWlXJwzsHFx9VExigN1SSE0ozHYkHAbczgIhAMOCASO6rMSFvlE2juzyIqjYMpkZSAIU7ixN7qCqZqPD",
  class: "eethree"
}, "标识编号 20200618161647473")],
-1));
const _hoisted_23 = { style: { "margin-bottom": "8px" } };
const _hoisted_24 = { style: { "margin-bottom": "8px" } };
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
/*#__PURE__*/_createElementVNode("span", { style: { "padding": "2px 0" } }, "主办单位：上海乙十生物医疗科技有限公司")],
-1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: { "height": "30px" } }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_NavMenu = _resolveComponent("NavMenu");
  const _component_el_affix = _resolveComponent("el-affix");
  const _component_el_header = _resolveComponent("el-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_footer = _resolveComponent("el-footer");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [
  _createVNode(_component_el_container, null, {
    default: _withCtx(() => [
    _createVNode(_component_el_header, null, {
      default: _withCtx(() => [
      _createVNode(_component_el_affix, null, {
        default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_image, {
          style: { "width": "27px", "height": "27px", "margin": "auto 0" },
          src: require('./assets/home-phone.png'),
          fit: "fill",
          loading: "lazy"
        }, null, 8, ["src"]),
        _hoisted_4,
        _createElementVNode("div", {
          style: { "margin-left": "177px", "width": "38px", "cursor": "pointer" },
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.jumpToPage('/aboutUs', '5-4', true))
        }, _hoisted_6),
        _createElementVNode("div", {
          style: { "margin-left": "97px", "width": "38px", "cursor": "pointer" },
          onClick: _cache[1] || (_cache[1] = ($event) => _ctx.jumpToPage('/aboutUs', '5-4', true))
        }, _hoisted_8),
        _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_tooltip, {
          effect: "light",
          content: _ctx.downloadContext,
          "raw-content": "",
          placement: "bottom",
          "popper-class": "test"
        }, {
          default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_image, {
            style: { "width": "24px", "height": "24px", "margin-top": "8px", "margin-left": "10px" },
            src: require('./assets/home-download.png'),
            fit: "fill",
            loading: "lazy"
          }, null, 8, ["src"])]
          )]
          ),
          _: 1
        }, 8, ["content"])]
        )]
        )]
        ),
        _createVNode(_component_NavMenu)]
        ),
        _: 1
      })]
      ),
      _: 1
    }),
    _createVNode(_component_el_main, null, {
      default: _withCtx(() => [
      _createVNode(_component_router_view)]
      ),
      _: 1
    }),
    _createVNode(_component_el_footer, null, {
      default: _withCtx(() => [
      _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", {
        style: { "cursor": "pointer" },
        onClick: _cache[2] || (_cache[2] = ($event) => _ctx.backToHome())
      }, [
      _createVNode(_component_el_image, {
        style: { "width": "75px", "height": "75px", "margin-top": "65px", "margin-bottom": "30px" },
        src: "https://oss.bioyishi.com/imgs/yssm_circular_transparent_max.png"
      }),
      _hoisted_14,
      _hoisted_15]
      ), (
      _openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navMenuData, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item-footer",
          key: index
        }, [
        _createElementVNode("div", {
          style: { "font-size": "18px", "margin-bottom": "30px", "text-align": "left", "cursor": "pointer" },
          onClick: ($event) => _ctx.jumpToPage(item.index, item.child[0].index, false)
        }, _toDisplayString(item.name), 9, _hoisted_16), (
        _openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.child, (classificationItem, classificationIndex) => {
          return _openBlock(), _createElementBlock("div", {
            style: { "height": "40px", "line-height": "40px", "text-align": "left", "cursor": "pointer" },
            key: classificationIndex,
            onClick: ($event) => _ctx.jumpToPage(item.index, classificationItem.index, true)
          }, _toDisplayString(classificationItem.name), 9, _hoisted_17);
        }), 128))]
        );
      }), 128))]
      )]
      ),
      _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _hoisted_20,
      _hoisted_21,
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
      _createElementVNode("a", {
        class: "eethree",
        onClick: _cache[3] || (_cache[3] = ($event) => _ctx.openMask('https://oss.bioyishi.com/imgs/yishi/cert1.jpg'))
      }, " 乙十营业执照：27000000202103290314 "),
      _createTextVNode(" | "),
      _createElementVNode("a", {
        class: "eethree",
        onClick: _cache[4] || (_cache[4] = ($event) => _ctx.openMask('https://oss.bioyishi.com/imgs/hospital/cert1.png'))
      }, "医疗机构执业许可证：MA636B2P051011619A1002"),
      _createTextVNode(" | "),
      _createElementVNode("a", {
        onClick: _cache[5] || (_cache[5] = ($event) => _ctx.openMask(' https://oss.bioyishi.com/imgs/drug/cert1.jpg')),
        class: "eethree"
      }, "互联网药品信息服务资格证书-1:（沪）经营性-2021-0050")]
      ),
      _createElementVNode("div", _hoisted_24, [
      _createElementVNode("a", {
        onClick: _cache[6] || (_cache[6] = ($event) => _ctx.openMask('https://oss.bioyishi.com/imgs/device/cert1.jpg')),
        class: "eethree"
      }, "第二类医疗器械经营备案凭证:沪松食药监械经营备20212002号"),
      _createTextVNode(" | "),
      _createElementVNode("a", {
        onClick: _cache[7] || (_cache[7] = ($event) => _ctx.openMask('https://oss.bioyishi.com/imgs/device/cert2.png')),
        class: "eethree"
      }, "医疗器械网络交易服务第三方平台备案凭证:（沪）网械平台备字[2021]第00005号")]
      ),
      _hoisted_25,
      _hoisted_26]
      ),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.sendVal,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => _ctx.sendVal = $event)
      }, {
        default: _withCtx(() => [
        _createVNode(_component_el_image, {
          src: _ctx.imageUrl,
          fit: "fill"
        }, null, 8, ["src"])]
        ),
        _: 1
      }, 8, ["modelValue"])]
      ),
      _: 1
    })]
    ),
    _: 1
  })]
  );
}